import { createToolStore } from './create-tool-store'

export const useImageCompressorStore = createToolStore({ quality: 60 })
